import globalToast from "../components/common/globalToast";
import api from "../services/api";

const service_path = '/stone-variations.php';

export function getStoneVariations(id) {

    const response = api.get(`${service_path}?variation=${id}`);

    return response;
};

export function getStoneVariationDetails(id,) {

    const response = api.get(`${service_path}?id=${id}`)
    
    return response;
};

export function createStoneVariation(data, navigateBack) {

    api.post(service_path, data)
        .then(response => {

            const { data } = response;

            if (data.success) {
                globalToast.success("Conforto cadastrado com sucesso!");
                navigateBack();
            } else {
                globalToast.error(data.message);
            };
        })
        .catch(error => {
            console.log(error);
            globalToast.error('Houve um erro ao executar essa ação!');
        });
};

export function updateStoneVariation(data, navigateBack) {

    api.patch(service_path, data)
        .then(response => {

            const { data } = response;

            if (data.success) {
                globalToast.success("Conforto editado com sucesso!");
                navigateBack();
            } else {
                globalToast.error(data.message);
            };
        })
        .catch(error => {
            console.log(error);
            globalToast.error('Houve um erro ao executar essa ação!');
        });
};

export function deleteStoneVariation(id, user_id) {
    api.delete(service_path, { data: { id, user_id } })
        .then(response => {
            const { data } = response;
            if (data.success) {
                globalToast.success("Variação de pedra deletada com sucesso!")
            } else {
                globalToast.error('Houve um erro ao deletar essa variação de pedra!');
            };
        })
        .catch(error => {
            globalToast.error(error.response.data.message)
            console.log(error)
        });
};